export default "__VITE_ASSET__BPzdVlvv__"